/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_login_layout_carousel_title_1 = /** @type {(inputs: {}) => string} */ () => {
	return `Administra las finanzas de tu empresa con IA.`
};

const en_login_layout_carousel_title_1 = /** @type {(inputs: {}) => string} */ () => {
	return `Manage your company's finances with AI.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const login_layout_carousel_title_1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_layout_carousel_title_1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_layout_carousel_title_1", locale)
	if (locale === "es") return es_login_layout_carousel_title_1(inputs)
	return en_login_layout_carousel_title_1(inputs)
};
export { login_layout_carousel_title_1 as "login_layout.carousel.title_1" }